// hooks and utilities
import { useLanguage, useTranslateFunction } from "lang/Translate";
import useAircraftCrew from "hooks/useAircraftCrew";
import useRedirect from "hooks/useRedirect";
import useColors from "hooks/useColors";

// common components
import SlidingTextButton from "../SlidingTextButton/SlidingTextButton";

// styles
import "./CrewList.scoped.scss";
import Aircraft from "classes/aircraft";
import { useSelector } from "react-redux";

function CrewList({ aircraftIdent }) {
	if (typeof aircraftIdent !== "number") {
		throw new TypeError(`Prop 'aircraftIdent' expects value of type 'number' but got '${typeof aircraftIdent}'`);
	}

	const [pilotCrew, cabinCrew, purser] = useAircraftCrew(aircraftIdent);
	const translate = useTranslateFunction();
	const [, color] = useColors(aircraftIdent);
	const currLanguage = useLanguage();
	const redirect = useRedirect();
	const hub = useSelector(s => s.airlineInfo.hubs[0]);

	function disableEditCrew() {
		const aircraft = Aircraft.get(aircraftIdent);
		if (["inflight", "delivery"].includes(aircraft.status)) return true;
		if (aircraft.missingCrewCount > 0) return false;
		return hub !== aircraft.location;
	}

	return (
		<>
			{pilotCrew.map(({ name, icon, worker }) => (
				<div className="item" key={name[0]}>
					<div className="header">
						<i className={icon} />
						{currLanguage === "PL" ? name[1] : name[0]}
					</div>
					<div className="content">{worker?.name || "Brak"}</div>
				</div>
			))}

			{purser.length > 0 && (
				<div className="item">
					<div className="header">
						<i className="fas fa-bell-concierge" />
						{translate("PURSER", "Fleet->Details->StaffManager")}
					</div>

					<div className="content">{purser[0]?.name || "Brak"}</div>
				</div>
			)}

			{cabinCrew.length > 0 && (
				<div className="item">
					<div className="header">
						<i className="fas fa-bell-concierge" />
						{translate("CABIN_CREW", "Fleet->Details->StaffManager")}
					</div>
					{cabinCrew.map((worker, i) => (
						<div className="content" key={i}>
							{worker?.name || "Brak"}
						</div>
					))}
				</div>
			)}

			<div className="margin" />
			<SlidingTextButton
				text={translate("EDIT", "CrewList")}
				icon={<i className="fas fa-pen" />}
				onClick={() => redirect(`aircraftIcon.fleet.overview.details~${aircraftIdent}.staff`)}
				disabled={disableEditCrew()}
				background={color}
			/>
		</>
	);
}

export default CrewList;
